import axios from "axios";
import { fetchWithRetry } from "../../common/fetchWithRetryFunction";
import { getCountry } from "@/common/userfuctions";
import { COUNTRY_VARIABLES } from "@/constant/constantVar";

const encodeProtectedParam = (value) => {
  if (!value || typeof value !== "object" || typeof value.p !== "string") return value;
  return {
    ...value,
    p: value.p.replace(/%/g, "\\u0025").replace(/'/g, "\\u0027"),
  };
};

export const post = (url, data, params, moreParams = {}, retryOpts = {}) => {
  const requestTimeout = retryOpts?.timeout ?? 60000;
  let headers = {};
  if (moreParams?.req?.headers["x-forwarded-for"])
    headers = {
      "x-forwarded-for": moreParams?.req.headers["x-forwarded-for"],
    };

  const paramsObjectString = params?.p;
  if (typeof paramsObjectString === 'string') {
    const paramsObject = JSON.parse(paramsObjectString);
    //check if IPCountry key is already present
    if (!paramsObject.hasOwnProperty('IPCountry')) {
      paramsObject['IPCountry'] = COUNTRY_VARIABLES.countryCode;
    }
    params.p = JSON.stringify(paramsObject);
  }
  let requestData = encodeProtectedParam(data);
  let requestParams = encodeProtectedParam(params);
  // Rich-text job descriptions can exceed the browser/server URL limit.
  // The API accepts `p` from the POST body when it is not present in the query.
  if (typeof requestParams?.p === "string" && requestParams.p.length > 6000) {
    requestData = { ...(requestData || {}), p: requestParams.p };
    requestParams = { ...requestParams };
    delete requestParams.p;
  }
  return new Promise((resolve, reject) => {
    fetchWithRetry(() => axios
      .post(url, requestData, {
        params: requestParams,
        headers: headers,
        timeout: requestTimeout,
      }), { ...retryOpts, url })
      .then(function (response) {
        if (response?.data?.Status == -1) {
          if (typeof window !== "undefined") {
            const event = new CustomEvent("reauth", {
              detail: {
                reAuth: true,
              },
            });
            window.dispatchEvent(event);
          }
          resolve(response.data);
        }
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error)
      });
  });
};

// export const post = async (url, data, params) => {
//   try {
//     let response = await axios.post(url, data, { params: params });
//     return response.data;
//   } catch (error) {    
//     return error;
//   }
// };

export const get = (url, params, token) => {
  const requestParams = encodeProtectedParam(params);
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: requestParams })
      .then(function (response) {
        if (response.data.Status == -1) {
          const event = new CustomEvent("reauth", {
            detail: {
              reAuth: true,
            },
          });
          window.dispatchEvent(event);
        }
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const upload = (url, formData, params, onProgress) => {
  const config = {
    onUploadProgress: (progressEvent) => {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      if (onProgress) onProgress(percentCompleted);
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: encodeProtectedParam(params),
  };

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      axios
        .post(url, formData, config)
        .then(function (response) {
          if (response.data.Status == -1) {
            const event = new CustomEvent("reauth", {
              detail: {
                reAuth: true,
              },
            });
            window.dispatchEvent(event);
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        }, 1000);
    });
  });
};

export const download = (url, data, params) => {
  const requestData = encodeProtectedParam(data);
  const requestParams = encodeProtectedParam(params);
  return new Promise((resolve, reject) => {
    axios
      .post(url, requestData, { params: requestParams, responseType: "blob" })
      .then(function (response) {
        if (response.data.Status == -1) {
          const event = new CustomEvent("reauth", {
            detail: {
              reAuth: true,
            },
          });
          window.dispatchEvent(event);
        }
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const PostWithData = (url, formData, params, onProgress) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: encodeProtectedParam(params),
  };

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      axios
        .post(url, encodeProtectedParam(formData), config)
        .then(function (response) {

          if (response?.data?.Status == -1) {
            if (typeof window !== "undefined") {
              const event = new CustomEvent("reauth", {
                detail: {
                  reAuth: true,
                },
              });
              window.dispatchEvent(event);
            }
            resolve(response.data);
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        }, 1000);
    });
  });
};
